<div class="selected-files">
  <div class="selected-files__headline">
    <h5 class="bold">
      {{ text | translate }}
    </h5>
  </div>

  <div class="selected-files__file-container">
    <div class="selected-files__images" #selectedImgContainer>
      @if (!getFiles().length) {
        <i class="selected-files__image-icon icon-image"></i>
      }
      @else {
        <div class="selected-files__image-container">
          @for (file of getFiles(); track $index) {
            <ng-container>
              @if (getFiles().length) {
                <div
                  class="selected-files__image"
                  [ngClass]="{'hideSelected': isChosen(file)}"
                >
                  <app-thumbnail
                    class="selected-files__thumbnail-container"
                    [ngClass]="{'active': showSelected && isSelectedFile($index)}"
                    [item]="file"
                    (click)="setFile(file)"
                    [_snackBar]="_snackBar"
                    [imageIdField]="imageIdField"
                    [stylingClass]="'image-uploaded-edit'"
                  ></app-thumbnail>

                  @if (!showSelected) {
                    <ng-container>
                      <a
                        class="selected-files__image-delete"
                        (click)="deleteFile(file)"
                      >
                        <i class="icon-trash"></i>
                      </a>
                    </ng-container>
                  }
                  @else {
                    <ng-container>
                      @if (isSelectedFile($index)) {
                        <a class="selected-files__image-selected">
                          <mat-icon>
                            check
                          </mat-icon>
                        </a>
                      }
                    </ng-container>
                  }
                </div>
              }
            </ng-container>
          }
        </div>
      }
    </div>
  </div>

  @if (showSelected) {
    <div class="selected-files__select-button-container">
      <span  class="selected-files__selected-items-text">
        <span>
          {{chosenItems.length}}
        </span>

        <span>
          {{ 'TRANS__SELECT_IMAGES__CHOSEN' | translate }}
        </span>
      </span>

      <button
        mat-flat-button
        color="accent"
        (click)="selectFile()"
        [disabled]="chosenItems.length === 0"
      >
        <span class="bold uppercase">
          {{ 'TRANS__SELECT_IMAGES__CHOOSE_IMAGE' | translate }}
        </span>
      </button>
    </div>
  }
</div>
